import PassengerSummaryCard from "../PassengerSummaryCard/PassengerSummary";
import { TripMoneyBreakdown, JourneySummaryCard } from "..";
import { useJourneyStaticDetails } from "../../context";
import { JourneyStaticDetailsContext } from "../../context/JourneyStaticDetails";
import { BridgeProvider } from "src/context/BridgeContext";

export default function JourneySidebar() {
  const { journeySearchData } = useJourneyStaticDetails();
  return (
    <div className="flex flex-col gap-3">
      <PassengerSummaryCard />
      <div>
        <BridgeProvider context={JourneyStaticDetailsContext}>
          <JourneySummaryCard journey={journeySearchData} />
        </BridgeProvider>
      </div>
      <div className="custom-scrollbar sticky top-10">
        <TripMoneyBreakdown />
      </div>
    </div>
  );
}
